import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';

/**
 * Ошибки, где responseType: 'blob' прилетают как 'json'.
 * Переделываем ошибку в json, чтобы в последствии можно было обработать, например в AuthInterceptor.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorNormalizerInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((errResponse) => {
        if (errResponse instanceof HttpErrorResponse) {
          if (errResponse.error instanceof Blob && errResponse.error.type === 'application/json') {
            return from(errResponse.error.text()).pipe(
              concatMap((text) =>
                throwError(
                  () =>
                    new HttpErrorResponse({
                      error: JSON.parse(text),
                      headers: errResponse.headers,
                      status: errResponse.status,
                      statusText: errResponse.statusText,
                      url: errResponse.url,
                    }),
                ),
              ),
            );
          }
        }

        return throwError(() => errResponse);
      }),
    );
  }
}
